module.exports = __webpack_public_path__ + "static/media/25.868a94ad.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/25.JPG
// module id = 468
// module chunks = 0